import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <video
        src="https://public.readdy.ai/ai/video_res/019fb21d-671c-7ed1-9f0f-fe950218f15e.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center max-w-5xl mx-auto" style={{ textShadow: '0 2px 16px rgba(0,0,0,0.7)' }}>
        <p className="text-accent-400 text-base md:text-xl tracking-[0.2em] mb-6 font-label">
          AIGC 彩色書籍、科普與歷史類書籍
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          清文華泉 Cinva
        </h1>
        <p className="text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed mb-10">
          清文華泉 Cinva 以 AIGC 彩色書籍、科普與歷史類書籍為主要出版方向。本品牌委託崧博出版經銷，官方網站由崧博出版製作。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-secondary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-secondary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            認識清文華泉
            <i className="ri-arrow-right-line"></i>
          </Link>
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            前往崧博出版書籍資料庫
            <i className="ri-external-link-line"></i>
          </a>
          <Link
            to="/stores"
            className="inline-flex items-center gap-2 bg-secondary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-secondary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看購書通路
            <i className="ri-store-2-line"></i>
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            常見問題
            <i className="ri-question-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-background-300/50 rounded-full flex items-start justify-center">
          <div className="w-1 h-2 bg-background-300/60 rounded-full mt-1.5 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}